import axios from 'axios';

interface ViaCepResponse {
  erro?: boolean | string;
  cep?: string;
}

interface OpenCepResponse {
  erro?: boolean;
  cep?: string;
}

export const validateCep = async (cep: string): Promise<boolean> => {
  const cleanCep = cep.replaceAll(/\D/g, '');

  if (cleanCep.length !== 8) {
    return false;
  }

  try {
    const response = await axios.get<ViaCepResponse>(`https://viacep.com.br/ws/${cleanCep}/json/`, { timeout: 5000 });

    if (response.data?.erro === true || response.data?.erro === 'true') {
      return false;
    }

    return true;
  } catch {
  }

  try {
    const response = await axios.get<OpenCepResponse>(`https://opencep.com/v1/${cleanCep}`, { timeout: 5000 });

    if (response.status === 200 && response.data?.cep) {
      return true;
    }

  } catch (error: any) {
    if (error.response?.status === 404) {
      return false;
    }
  }

  return true;
};
